var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRenticBgElement2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 369.71 602.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        opacity: .4;\n        stroke: #3e83bb;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 369.71,
    height: 602.71
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "die_line",
    "data-name": "die line"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 22.35,
    y: 17.77,
    width: 628.65,
    height: 628.65,
    rx: 43.35,
    ry: 43.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.39,
    y: 45.65,
    width: 628.65,
    height: 628.65,
    rx: 43.35,
    ry: 43.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 95.65,
    y: 75.06,
    width: 628.65,
    height: 628.65,
    rx: 43.35,
    ry: 43.35
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenticBgElement2);
export default __webpack_public_path__ + "static/media/rentic_bg_element2.2fb9dcda2fa7184b75d30c31a958d983.svg";
export { ForwardRef as ReactComponent };